export const UPLOAD_ACTION_URL = '/api/admin/v1/resources/media/upload';
